import { authActions } from "../slices/authSlice";
import { toast } from "react-toastify";
import axios from "axios";


//Register user
export function registerUser(user) {
  return async (dispatch) => {
    try {
      const { data } = await axios.post(`https://tabeeb-assyut-api.onrender.com/api/auth/register`, user);
      dispatch(authActions.register(data?.message));
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };
}
//Login user
export function loginUser(user) {
  return async (dispatch) => {
    try {
      const { data } = await axios.post(`https://tabeeb-assyut-api.onrender.com/api/auth/login`, user);
      dispatch(authActions.login(data));
      localStorage.setItem("userInfo", JSON.stringify(data));
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };
}
//Logout user
export function logoutUser() {
  return (dispatch) => {
    dispatch(authActions.logout());
    localStorage.removeItem("userInfo");
  };
}

//Verify  Email
export function verifyEmail(userId, token) {
  return async (dispatch) => {
    try {
      await axios.get(`https://tabeeb-assyut-api.onrender.com/api/auth/${userId}/verify/${token}`);
      dispatch(authActions.setIsEmailVerified());
    } catch (error) {
      console.log(error);
      toast.error(error.response);
    }
  };
}
